export default "/_next/static/a7182928d7626183b0d867400e337915.png";